import { gql } from '@apollo/client';

export const GET_COLLECTIONS_FOR_GEOGRAPHY = gql`
  query GetCollectionsForGeography($geographyId: Int!) {
    collectionsForGeography(geographyId: $geographyId) {
      orderingEntries {
        id
        position
        specialCollection
        isDesignatedForLeaderboard
        collection {
          id
          name
          shortName
          description
          iconIndicator
          status
          urlSlug
          collectionEntrys {
            id
            resyVenueId
            tockVenueId
          }
        }
      }
      unorderedCollections {
        id
        name
        shortName
        description
        iconIndicator
        status
        urlSlug
        collectionEntrys {
          id
          resyVenueId
          tockVenueId
        }
      }
    }
  }
`;

export const getCollectionsForGeographyRefetch = (geographyId: number) => [
  {
    query: GET_COLLECTIONS_FOR_GEOGRAPHY,
    variables: { geographyId },
  },
];
